import { Flex } from 'antd';
import { ErrorBox } from '~/app/components/common/Error/ErrorBox';
import { Loader } from '~/app/components/common/Loader/Loader';
import { ChargingKpisSection } from './components/ChargingKpisSection/ChargingKpisSection';
import { DashboardHeader } from './components/DashboardHeader/DashboardHeader';
import { OperationsKpisSection } from './components/OperationsKpisSection/OperationsKpisSection';
import { PropertyPortfolioTable } from './components/PropertyPortfolioTable/PropertyPortfolioTable';
import type { OrganizationManagerDashboardPageViewProps } from './OrganizationManagerDashboardPage.types';

export function OrganizationManagerDashboardPageView(
  props: OrganizationManagerDashboardPageViewProps,
) {
  const {
    isLoading,
    isError,
    errorTitle,
    errorMessage,
    greeting,
    subtitle,
    period,
    periodOptions,
    periodAriaLabel,
    refreshAriaLabel,
    refreshLoading,
    viewDetailsLabel,
    accountabilityTitle,
    accountabilitySubtitle,
    portfolioTitle,
    portfolioColumns,
    portfolioRows,
    portfolioRefreshing,
    onPeriodChange,
    onRefresh,
    onViewDetails,
  } = props;

  if (isLoading) {
    return (
      <div className="om-dashboard-page om-dashboard-page--state">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="om-dashboard-page om-dashboard-page--state">
        <ErrorBox title={errorTitle} description={errorMessage} />
      </div>
    );
  }

  return (
    <div className="om-dashboard-page">
      <div className="app-page app-page--dashboard om-dashboard">
        <Flex vertical gap={24}>
          <DashboardHeader
            greeting={greeting}
            subtitle={subtitle}
            period={period}
            periodOptions={periodOptions}
            periodAriaLabel={periodAriaLabel}
            refreshAriaLabel={refreshAriaLabel}
            refreshLoading={refreshLoading}
            onPeriodChange={onPeriodChange}
            onRefresh={onRefresh}
          />

          <ChargingKpisSection
            period={period}
            errorTitle={errorTitle}
            viewDetailsLabel={viewDetailsLabel}
            onViewDetails={onViewDetails}
          />

          <OperationsKpisSection
            period={period}
            errorTitle={errorTitle}
            accountabilityTitle={accountabilityTitle}
            accountabilitySubtitle={accountabilitySubtitle}
            viewDetailsLabel={viewDetailsLabel}
            onViewDetails={onViewDetails}
          />

          <div
            className={
              portfolioRefreshing
                ? 'om-dashboard-section--refreshing'
                : undefined
            }
          >
            <PropertyPortfolioTable
              title={portfolioTitle}
              columns={portfolioColumns}
              rows={portfolioRows}
            />
          </div>
        </Flex>
      </div>
    </div>
  );
}
